module.exports = __webpack_public_path__ + "static/media/team.3342833d.svg";